// extracted by mini-css-extract-plugin
export var darkColor = "#262626";
export var infoColor = "#6bdcff";
export var lightColor = "#eee";
export var montserratFont = "Montserrat";
export var primaryColor = "#0986ad";
export var secondaryColor = "#666";